export const seasonsQueryKeys = {
  all: ["seasons"] as const,
  list: ({ sport, organizationId, search }: { sport: string; organizationId: string; search: string }) =>
    [...seasonsQueryKeys.all, "list", sport, organizationId, search] as const,
};
